"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _americanFootball = _interopRequireDefault(require("./americanFootball"));

var _australianFootball = _interopRequireDefault(require("./australianFootball"));

var _baseball = _interopRequireDefault(require("./baseball"));

var _basketball = _interopRequireDefault(require("./basketball"));

var _boxing = _interopRequireDefault(require("./boxing"));

var _cricket = _interopRequireDefault(require("./cricket"));

var _esports = _interopRequireDefault(require("./esports"));

var _football = _interopRequireDefault(require("./football"));

var _iceHockey = _interopRequireDefault(require("./iceHockey"));

var _mma = _interopRequireDefault(require("./mma"));

var _rugbyLeague = _interopRequireDefault(require("./rugbyLeague"));

var _rugbyUnion = _interopRequireDefault(require("./rugbyUnion"));

var _tennis = _interopRequireDefault(require("./tennis"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var sportsIcons = {
  americanFootball: _americanFootball["default"],
  australianFootball: _australianFootball["default"],
  baseball: _baseball["default"],
  basketball: _basketball["default"],
  boxing: _boxing["default"],
  cricket: _cricket["default"],
  esports: _esports["default"],
  football: _football["default"],
  iceHockey: _iceHockey["default"],
  mma: _mma["default"],
  rugbyLeague: _rugbyLeague["default"],
  rugbyUnion: _rugbyUnion["default"],
  tennis: _tennis["default"]
};
var _default = sportsIcons;
exports["default"] = _default;